import { Link } from "react-router-dom";
import { ArrowLeft, LogOut } from "lucide-react";
import { LOGO_URL } from "@/lib/api";
import { AWAKE_URLS } from "@/lib/memberSession";
import useMemberSession from "@/hooks/useMemberSession";

export default function Header({ minimal = false }) {
    const { isMember, logout } = useMemberSession();

    return (
        <header
            className="w-full border-b border-weave-border bg-weave-bg"
            data-testid="site-header"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between py-5">
                <Link
                    to="/"
                    className="flex items-center gap-3"
                    data-testid="header-logo"
                >
                    <img
                        src={LOGO_URL}
                        alt="The Weave"
                        className="h-9 w-auto"
                    />
                    <span className="hidden md:flex flex-col leading-tight">
                        <span className="editorial-label text-weave-slate">
                            Opportunity Unlock
                        </span>
                        <span className="text-[10px] uppercase tracking-editorial text-weave-teal font-medium">
                            Experience, rewoven
                        </span>
                    </span>
                </Link>

                {!minimal && isMember && (
                    <nav
                        className="flex items-center gap-6 text-sm"
                        data-testid="header-member-nav"
                    >
                        <a
                            href={AWAKE_URLS.dashboard}
                            className="weave-link inline-flex items-center gap-1.5"
                            data-testid="header-back-to-dashboard"
                        >
                            <ArrowLeft className="w-3.5 h-3.5" />
                            Back to your dashboard
                        </a>
                        <button
                            type="button"
                            onClick={logout}
                            className="btn-ghost"
                            data-testid="header-logout"
                        >
                            <LogOut className="w-3.5 h-3.5" />
                            Log out
                        </button>
                    </nav>
                )}

                {!minimal && !isMember && (
                    <nav
                        className="flex items-center gap-6 text-sm"
                        data-testid="header-guest-nav"
                    >
                        <a
                            href={AWAKE_URLS.login}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="weave-link hidden md:inline-flex"
                            data-testid="header-club-login"
                        >
                            1% Club login
                        </a>
                        <a
                            href={AWAKE_URLS.join}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-secondary text-xs py-2 px-4"
                            data-testid="header-club-join"
                        >
                            Join the 1% Club
                        </a>
                    </nav>
                )}
            </div>
        </header>
    );
}
